var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-switch", {
        attrs: {
          label: _vm.contextWorkflowData.isCustomizedWorkflowEnabled
            ? _vm.$t("settings.workflow.customizedWorkflowEnabled")
            : _vm.$t("settings.workflow.customizedWorkflowDisabled")
        },
        model: {
          value: _vm.contextWorkflowData.isCustomizedWorkflowEnabled,
          callback: function($$v) {
            _vm.$set(
              _vm.contextWorkflowData,
              "isCustomizedWorkflowEnabled",
              $$v
            )
          },
          expression: "contextWorkflowData.isCustomizedWorkflowEnabled"
        }
      }),
      _vm.contextWorkflowData.isCustomizedWorkflowEnabled
        ? _c("workflow-item", {
            attrs: { item: _vm.contextWorkflowData.workflow },
            on: {
              "update:item": function($event) {
                return _vm.$set(_vm.contextWorkflowData, "workflow", $event)
              }
            }
          })
        : _vm._e(),
      _vm.contextWorkflowData.isCustomizedWorkflowEnabled
        ? _c("v-select", {
            attrs: {
              label: _vm.$t("settings.workflow.decisionAs"),
              items: _vm.users,
              "item-value": "id",
              "item-text": "fullName",
              rules: [
                function(v) {
                  return (
                    (v !== null && v !== "") || _vm.$t("global.error.required")
                  )
                }
              ]
            },
            model: {
              value: _vm.contextWorkflowData.signAs,
              callback: function($$v) {
                _vm.$set(_vm.contextWorkflowData, "signAs", $$v)
              },
              expression: "contextWorkflowData.signAs"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }